import styled from "styled-components";
import ButtonIcon from "../../ui/ButtonIcon";
import { HiOutlineMagnifyingGlass, HiOutlineXCircle } from "react-icons/hi2";
import { useSearchParams } from "react-router-dom";
import { searchTypes } from "./searchTypes";
import { useSearchStore } from "@/stores/SearchStore";
import { usePostHog } from "posthog-js/react";

const StyledSearchBox = styled.div`
  flex: 1;
  width: 0;
  display: flex;
  /* justify-self: center; */
  border: 1px solid var(--gray-300);
  border-radius: 0.5rem;
  width: 66%;
  /* margin-left: auto; */
  padding-right: 6px;
  transition: all 0.3s;
  background-color: var(--neutral);
  align-items: center;
  &::placeholder {
    color: var(--gray-400);
  }
  &:hover,
  &:focus-within {
    box-shadow: var(--shadow-md);
    transform: translateY(-2px);
    border-color: var(--brand-600);
  }
`;
const SearchInput = styled.input`
  border: none;
  font-size: 1.2rem;
  width: 100%;
  padding: 0.75rem 6px 0.5rem 2rem;
  border-radius: var(--border-radius-xxlg);
  margin: auto;
  &::placeholder {
    color: var(--gray-400);
  }
  &:focus {
    outline: none;
  }
  background-color: transparent;
`;

const EraseButton = styled.button`
  transition: inherit;
  border-radius: var(--border-radius-xxlg);
  margin: auto;

  &:hover {
    svg {
      color: var(--gray-400);
    }
    background-color: transparent;
    box-shadow: var(--shadow-md);
    transform: translateY(-2px);
  }
  &:focus {
    outline: none;
  }

  & svg {
    width: 1.4rem;
    height: auto;
    color: var(--gray-300);
  }
`;

function SearchBox({ searchTerm, setSearchTerm }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const posthog = usePostHog();
  const searchType = searchParams.get("searchType") || "federal";

  function onSearch() {
    searchParams.set("val", searchTerm);
    setSearchParams(searchParams);
    useSearchStore.setState({ searchPageSearchParams: searchParams });
    if (searchTerm.trim() !== "") {
      posthog?.capture("opportunity_search");
    }
  }

  return (
    <StyledSearchBox>
      <SearchInput
        value={searchTerm}
        placeholder={`Search for ${searchTypes[searchType].value} opportunities`}
        onChange={(e) => {
          setSearchTerm(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault(); // Prevent the default form submission (if inside a form)
            onSearch();
          }
        }}
      />
      <EraseButton hidden={!searchTerm} onClick={() => setSearchTerm("")}>
        <HiOutlineXCircle />
      </EraseButton>
      <ButtonIcon
        id="search-button"
        variant="link"
        onClick={() => {
          onSearch();
        }}
      >
        <HiOutlineMagnifyingGlass />
      </ButtonIcon>
    </StyledSearchBox>
  );
}

export default SearchBox;
